/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const BLUEPRINT_CONFIG = {
    Circle: {
        items: [
            {
                backgroundColor: '#2dc937',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'green',
            },
            {
                backgroundColor: '#e7b416',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'amber',
            },
            {
                backgroundColor: '#cc3232',
                size: 80,
                borderWidth: 8,
                bordercolor: '#000000',
                key: 'red',
            },
        ],
    },
};

export const PRODUCT ={
    title: "",
    subtitle: '',
    qtyKey: 'Vol.',
    qtyValue: '',
    priceKey: 'Price',
    priceValue: '₹ 726.11',
}


export const PRODUCT_IMG =[

    {
        original: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnail: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnailHeight: "100",
        thumbnailClass:"image-thumb",
    },
    {
      original: 'https://i.ibb.co/563WfWT/DSP-Black.png',
      thumbnail: 'https://i.ibb.co/563WfWT/DSP-Black.png',
        thumbnailHeight: "100",
        thumbnailClass:"image-thumb",
    },
]


export const PROVENANCE = {
    data: [
      {
        title: '1',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'dispatch',
            title: 'Dispatch',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '12 May 2021',
          },
          {
            tag: 'dispatch',
            title: 'Dispatch',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '12 May 2021',
          },
        ],
      },
      {
        title: '2',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'mrwFinishedGood',
            title: 'MRW Finished Good',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '24 May 2021',
          },
          {
            tag: 'bottling',
            title: 'Bottling',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '24 May 2021',
          },
        ],
      },
      {
        title: '3',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'blending',
            title: 'Blending',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '4',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'hbs',
            title: 'HBS',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: '14 May 2021',
          },
          {
            tag: 'bms',
            title: 'Blended Malt Spirit(BMS)',
            subtitle: ' MH',
            date: '14 May 2021',
          },
        ],
      },
      {
        title: '5',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'maturation',
            title: 'Maturation',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'ms12',
            title: 'Malt Spirit MS S 12',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'mss02',
            title: 'Malt Spirit MS S 02',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '6',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'distillation',
            title: 'Distillation',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'cmms',
            title: 'CMMS (MS  C18)',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'lowWineMalt',
            title: 'LOW WINE - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'washMalt',
            title: 'WASH - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
          {
            tag: 'wortMalt',
            title: 'WORT - MALT',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '7',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: '8',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United ',
            date: 'DD MMM YYYY',
          },
        ],
      },
      {
        title: "8",
        subtitle: "LEVEL",
        data: [
          {
            tag: "malting",
            title: "Malting",
            subtitle: "WASH - MALT",
            date: 'DD MMM YYYY',
           
          }
        ]
      },
      {
        title: '9',
        subtitle: 'LEVEL',
        data: [
          {
            tag: 'malting',
            title: 'Malting',
            subtitle: 'United Spirits Limited, Parmori, Dindori, Nashik, MH',
            date: 'DD MMM YYYY',
          },
        ],
      },
    ],
  };


  export const FEEDBACK_BUTTON ={
    title:"Feedback"
  }

  export const PROMO_BUTTON ={
    title:"Visit"
  }

  export const MODAL_FEEDBACK_CARD ={
    title: "feedback",
    prodImage: "https://i.ibb.co/563WfWT/DSP-Black.png",
    prodTitle: "Director's special black whisky",
    prodSubTitle: "Premium extension of Director's Special Whisky",
    prodPrice: "726.11",
  
  }

  export const FOR_CAMPAIGN = {
    "persona": {
      "personaName": "Customer",
      "sdrPersonaTx": "60cb4e990101a80a6824ce80",
      "filterData": {
        "totalcredsFetched": 0,
        "allowedcreds": 40,
        "finalcreds": 0
      },
      "altFieldMap": {
        "mappedCount": 0,
        "isAltmapFound": false
      }
    },
    "others": {
      "isAgeVerReq": true,
      "age_popup_details": {
        "_id": "62e39c0d05dcd3b09b55b832",
        "name": "default",
        "ageVerifcationData": {
          "wordings": "You must be 25 or above to view the details of this product. Click exit below if you do not meet this requirement. It’s part of our commitment to responsible drinking.",
          "checkbox_wording": [
            {
              "data": "By continuing further, you are accepting Diageo’s hyperlink1 of use.",
              "hyperlink1": {
                "display_name": "privacy policy",
                                "url": "https://footer.diageohorizon.com/dfs/assets/www.diageoindia.com/www.diageoindia.com_en-in_final_PrivacyPolicy.html"
              }
            }
          ]
        }
      }
    },
    "product": {
      "images": [
                "https://charity-test.s3.ap-south-1.amazonaws.com/xKGEf4ztKZeNNY8sGJUAzproductImage1"
      ],
      "videos": [],
      "title": "Vlinder Bottle",
      "subtitle": "<p><strong>Vlinder</strong> illustrative bollte product</p>\n\n<ul>\n\t<li>Point 1</li>\n\t<li>point 2</li>\n</ul>\n",
      "qtyKey": "quantity",
      "qtyValue": "250ml",
      "priceKey": "Price",
      "authenticityFlag": null,
      "isCampaignPresent": false,
      "batch": "batch 1004221",
      "gtin": "V00000100422"
    },
    "provenance": {
      "data": []
    },
    "campaigns": [
      {
        "status": "active",
        "campaignTemplateId": [
          "62fbbc12970e450d1c27558a"
        ],
        "_id": "633c39db38dd05122e0b93a9",
        "name": "Vlinder Bottle Consumer Campaign",
        "description": "test",
        "data": [
          {
            "_id": "633c39db38dd05122e0b93aa",
            "type": "still-picture",
            "typeProps": {
              "_id": "633c39db38dd05122e0b93ab",
              "title": {
                "_id": "633c39db38dd05122e0b93ac",
                "primaryTitle": null,
                "secondaryTitle": null,
                "text": "Seasons greetings",
                "textStyle": {
                  "_id": "633c39db38dd05122e0b93ad",
                  "color": "#fff"
                }
              },
              "message": {
                "_id": "633c39db38dd05122e0b93ae",
                "text": "Greeting to Vlinder :fire: ",
                "textStyle": null
              },
              "comp": {
                "_id": "633c39db38dd05122e0b93af",
                                "uri": "https://charity-test.s3.ap-south-1.amazonaws.com/H7OnWTcxTVEOIEzh7gPhQstillImages1",
                "resizeMode": "contain",
                                "posterUri": "https://charity-test.s3.ap-south-1.amazonaws.com/EfNyMLBdki4XmzG5h1ua7coverImage1",
                "content": null
              },
              "button": {
                "_id": "633c39db38dd05122e0b93b0",
                "color": "#3247b7",
                "shadowColor": "#3247b7",
                "buttonColor": "#b52b57",
                "titleColor": "#d42222",
                "text": "Check In",
                                "uri": "https://www.google.com/"
              },
              "footer": null
            }
          }
        ],
        "creatorUser": "614ad8dbd8204953f8f74888",
        "createdAt": "2022-10-04T13:49:15.518Z",
        "updatedAt": "2022-10-04T13:51:06.884Z",
        "__v": 0
      }
    ],
    "batch": {
      "name": "batch 1004221",
      "_id": "633c377f38dd05122e0b8c9e"
    },
    "feedbackModal": {
      "title": "feedback",
      "prodImage": {
                "uri": "https://charity-test.s3.ap-south-1.amazonaws.com/xKGEf4ztKZeNNY8sGJUAzproductImage1"
      },
      "prodTitle": "Vlinder Bottle"
    },
    "allProvStepMap": {
      "allProvStepMapCardList": {
        "allProvStepMapCardList": []
      }
    }
  }

